import { render, staticRenderFns } from "./SituacaoCadastro.vue?vue&type=template&id=621b733c&"
import script from "./SituacaoCadastro.vue?vue&type=script&lang=js&"
export * from "./SituacaoCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports